import { useMemo } from "react";
import { useOrders } from "@/lib/OrdersContext";
import { PageHeader, DataTable } from "@/components/PageHeader";
import { COLUMNS } from "@/lib/workshop";

const HEAD = ["Matrícula", "Modelo", "Cliente", "Órdenes", "Estado actual"];

export default function VehiculosPage() {
  const { searchAll: filtered } = useOrders();
  const vehicles = useMemo(() => {
    const m = new Map();
    filtered.forEach((o) => {
      const key = o.vehiculoId || o.matricula;
      const v = m.get(key) || { key, matricula: o.matricula, modelo: o.modelo, cliente: o.cliente, ordenes: 0, ultimo: o };
      v.ordenes += 1;
      if (new Date(o.createdAt) > new Date(v.ultimo.createdAt)) v.ultimo = o;
      m.set(key, v);
    });
    return [...m.values()];
  }, [filtered]);

  const rows = vehicles.map((v) => (
    <tr key={v.key} data-testid={`vehicle-row-${v.key}`} className="border-b border-white/5 transition-colors hover:bg-white/[0.02]">
      <td className="px-5 py-3"><span className="font-mono-plate rounded border border-white/15 bg-black/40 px-2 py-0.5 text-xs font-bold">{v.matricula || "—"}</span></td>
      <td className="px-5 py-3 font-semibold">{v.modelo || "—"}</td>
      <td className="px-5 py-3 text-zinc-400">{v.cliente || "—"}</td>
      <td className="px-5 py-3">{v.ordenes}</td>
      <td className="px-5 py-3 text-zinc-400">{COLUMNS.find((c) => c.id === v.ultimo.estado)?.label || "Entregado"}</td>
    </tr>
  ));
  return (
    <>
      <PageHeader title="Vehículos" subtitle={`${vehicles.length} vehículos en el taller`} />
      <DataTable testid="vehicles-table" head={HEAD} rows={rows} empty="Aún no hay vehículos" />
    </>
  );
}
